/**
 * English translations (base locale)
 */

import type { TranslationStrings } from '../types';

export const en: TranslationStrings = {
  toolbar: {
    activate: 'Activate agent-ui-annotation',
    freeze: 'Freeze animations',
    unfreeze: 'Unfreeze animations',
    showMarkers: 'Show markers',
    hideMarkers: 'Hide markers',
    dotsMode: 'Dots only',
    copyToClipboard: 'Copy to clipboard',
    clearAll: 'Clear all',
    annotations: 'Annotations',
    toggleTheme: 'Toggle theme',
    settings: 'Settings',
    close: 'Close',
    copiedFeedback: 'Copied to clipboard!',
    clearedFeedback: 'Cleared all annotations',
  },
  popup: {
    close: 'Close',
    addFeedback: 'Add your feedback...',
    addFeedbackMulti: 'Add feedback for all selected elements...',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    addAnnotation: 'Add Annotation',
    addAnnotations: 'Add {{count}} Annotations',
    elementsSelected: '{{count}} elements selected',
    andMore: '...and {{count}} more',
  },
  settings: {
    title: 'Settings',
    outputLevel: 'Output Level',
    markerColor: 'Marker Color',
    blockInteractions: 'Block page interactions',
    blockInteractionsHint: 'Prevent clicks from activating buttons/links while annotating',
    showTooltips: 'Show tooltips',
    autoClearAfterCopy: 'Auto-clear after copy',
    outputLevels: {
      compact: 'Compact',
      standard: 'Standard',
      detailed: 'Detailed',
      forensic: 'Forensic',
    },
  },
  colors: {
    purple: 'Purple',
    blue: 'Blue',
    cyan: 'Cyan',
    green: 'Green',
    yellow: 'Yellow',
    orange: 'Orange',
    red: 'Red',
  },
  marker: {
    noComment: '(no comment)',
  },
  output: {
    pageFeedback: 'Page Feedback',
    noAnnotations: 'No annotations created.',
    viewport: 'Viewport',
    annotations: 'Annotations',
    location: 'Location',
    selectedText: 'Selected text',
    feedback: 'Feedback',
    component: 'Component',
    domPath: 'DOM Path',
    selector: 'Selector',
    elementDetails: 'Element Details',
    tag: 'Tag',
    id: 'ID',
    classes: 'Classes',
    attributes: 'Attributes',
    textContent: 'Text content',
    positionDimensions: 'Position & Dimensions',
    boundingBox: 'Bounding box',
    size: 'Size',
    accessibility: 'Accessibility',
    role: 'Role',
    interactive: 'Interactive',
    ariaLabel: 'ARIA Label',
    describedBy: 'Described by',
    tabIndex: 'Tab index',
    computedStyles: 'Computed Styles',
    context: 'Context',
    landmark: 'Landmark',
    parent: 'Parent',
    previousSibling: 'Previous sibling',
    nextSibling: 'Next sibling',
    multiSelectNote: 'Created via multi-select',
    metadata: 'Metadata',
    created: 'Created',
    updated: 'Updated',
    environment: 'Environment',
    url: 'URL',
    devicePixelRatio: 'Device pixel ratio',
    scrollPosition: 'Scroll position',
    timestamp: 'Timestamp',
    userAgent: 'User agent',
    totalAnnotations: 'Total annotations',
    yes: 'Yes',
    no: 'No',
    none: 'none',
  },
};
